import { MoveIcon } from "@/Icons/v2/Move";
import type { LibraryFile } from "@/pages/library_v2/components/filesView/types";
import { useTrans } from "@/translations";

import { type Ref } from "react";

import { Popover } from "@headlessui/react";

import { ActionButton } from "./actionButton";
import { MoveToFolderPopup } from "./moveToFolderPopup";

type Props = {
  file: LibraryFile;
  tooltipPlacement: "bottom" | "top";
  moveButtonRef: Ref<HTMLButtonElement>;
};

export const MoveToFolderAction: React.FC<Props> = ({
  file,
  tooltipPlacement,
  moveButtonRef,
}) => {
  const { t } = useTrans();

  return (
    <Popover>
      {({ open }) => (
        <>
          <ActionButton
            icon={<MoveIcon size={20} color="#1D1C1C" />}
            label={t("libraryPage:fileListActionMove")}
            buttonRef={moveButtonRef}
            placement={tooltipPlacement}
            popover
            tooltipHidden={open}
          />

          <MoveToFolderPopup file={file} />
        </>
      )}
    </Popover>
  );
};
